import { Box } from "lucide-react";

interface LogoBrandProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function LogoBrand({ size = "md", className = "" }: LogoBrandProps) {
  const sizes = {
    sm: { icon: "h-5 w-5", text: "text-lg" },
    md: { icon: "h-6 w-6", text: "text-xl" },
    lg: { icon: "h-7 w-7", text: "text-2xl" },
  };

  return (
    <span className={`flex items-center gap-2 ${className}`}>
      <Box className={`${sizes[size].icon} text-primary`} />
      <span className={`${sizes[size].text} font-bold text-foreground`}>
        mivobox<span className="text-muted-foreground">.com</span>
      </span>
    </span>
  );
}
